import ItemCollectionNarrow from './ItemCollectionNarrow';

export default ItemCollectionNarrow;
